import { render, staticRenderFns } from "./SkillCategory.vue?vue&type=template&id=5b34cb5c&scoped=true&"
import script from "./SkillCategory.vue?vue&type=script&lang=js&"
export * from "./SkillCategory.vue?vue&type=script&lang=js&"
import style0 from "./SkillCategory.vue?vue&type=style&index=0&id=5b34cb5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b34cb5c",
  null
  
)

export default component.exports